var React = require('react');

function HashtagInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"svg.icon-hashtag{--c:var(--icon-color,#fff)}.b{fill:var(--c);}.c{fill:none;stroke:var(--c);}")),React.createElement("circle",{"className":"c","cx":"8.17","cy":"8.17","r":"7.5","key":1}),React.createElement("path",{"className":"b","d":"M10.97,6.17h-1.1l.37-2h-.87l-.37,2h-1.11l.37-2h-.87l-.37,2h-1.21v.73h1.08l-.27,1.47h-1.25v.73h1.11l-.38,2.07h.87l.38-2.07h1.11l-.38,2.07h.87l.38-2.07h1.2v-.73h-1.06l.27-1.47h1.23v-.73Zm-3.48,2.2l.27-1.47h1.11l-.27,1.47h-1.11Z","key":2})]);
}

HashtagInline.defaultProps = {"id":"a","className":"icon-hashtag","viewBox":"0 0 16.35 16.35"};

module.exports = HashtagInline;

HashtagInline.default = HashtagInline;
